import React, { useState, useEffect } from "react";
import ellipse152 from "../../assets/images/ellipse152.png";
import ellipse153 from "../../assets/images/ellipse153.png";
import smallerblock from "../../assets/images/smallerblock.png";
import largerblock from "../../assets/images/largerblock.png";
import { withRouter } from "react-router-dom";
import { API } from "../../utilities/constants";
import CustomAxios, {
  CustomAxiosDE,
} from "../../utilities/service/api.service";
import {
  Row,
  Col,
  Select,
  Layout,
  Checkbox,
  TreeSelect,
  Button,
  Table,
  Modal,
  Radio,
} from "antd";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import envelope from "../../assets/images/envelope.png";
import "antd/dist/antd.css";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/loader";
import Wrapper from "../../components/wrapper";
import {
  getNielsenCustomerFilters,
  getNielsenProductFilters,
  setNielsenProdFilters,
  setNielsenCustFilters,
  setNielsenWeeklyCustFilters,
  setNielsenTableLoading,
  setnielsenTimePeriodCheckbox,
  setnielsenTimeframeCheckbox,
  setnielsencolumnSelectionCheckbox,
  setincludeAllCheckboxNielsen,
  setNielsenTableDataPreview,
  setNielsenTableDataPreviewColumns,
  setnumOfRows,
  setnumOfColumns,
  setNielsenTimeHorizonRadio,
  getNielsenKPIs,
  setDatasetNielsen,
  setNielsenYear,
  setNielsenYearPeriod,
  setNielsenYearPeriodWeek,
  setLoadingNielsen,
  setNielsenExportData,
  setNielsenExportDataLoading,
  setTimeSelectedDynamicWeeklyNielsen,
} from "../../slicers/nielsenfilters.slicer";
import { getNielsenBookmarks } from "../../slicers/bookmarks.slicer";
import { getEposKPIs } from "../../slicers/eposfilters.slicer";
import Bookmarks from "../../components/bookmark/bookmarks";
import CustFiltersSection from "./customerFilters";
import ProdFiltersSection from "./productFilters";
import CheckAuthorization from "../../utilities/auth/checkAuthorization";
import "../styling/nielsen.scss";
import { showErrorMessage } from "../../utilities/helperFns";

const { Content } = Layout;
const { SHOW_PARENT } = TreeSelect;
const Nielsen = (props) => {
  const { loading } = useSelector((state) => state.datasets);
  const [applyErrorMarket, setApplyErrorMarket] = useState(false);
  const [applyErrorCd, setApplyErrorCd] = useState(false);
  const [timePeriod, setTimePeriod] = useState([]);
  const [, setTimeSelected] = useState([]);
  const [loadingModal, setLoadingModal] = useState(false);
  const [, setLoadingPreviewModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openPreviewModal, setOpenPreviewModal] = useState(false);
  const [bookmarkModalOn, setBookmarkModalOn] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const dispatch = useDispatch();
  const { email_home } = useSelector((state) => state.hometab);
  const {
    nielsendropdownLoading,
    cust_data_filters_nielsen,
    cust_filters_nielsen,
    customerFiltersWeekly,
    prod_filters_nielsen,
    prod_data_filters_nielsen,
    periodicity,
    kpis,
    customer_market,
    customer_desc,
    nielsentableLoading,
    nielsentabledataPreview,
    nielsentabledataPreviewColumns,
    nielsenYear,
    nielsenYearPeriod,
    nielsenYearPeriodWeek,
    nielsentimeframeCheckbox,
    timeHorizonRadioNielsen,
    nielsen_columnSelectionCheckbox,
    nielsen_dataset_selected,
    includeAllCheckbox_nielsen,
    timeSelectedDynamicNielsen,
    previewFormatNielsen,
  } = useSelector((state) => state.nielsenfilters);
  const { timeSelection_calendar } = useSelector((state) => state.eposfilters);
  const includeAllLevels = [
    "customer_id__market",
    "customer_id__customer_desc",
    "customer_id__channel",
    "customer_id__retailer",
    "product_id__animal_type",
    "product_id__portfolio",
    "product_id__technology",
    "product_id__manufacturer",
    "product_id__brand",
    "product_id__local_manufacturer",
    "product_id__local_brand",
    "product_id__sub_brand",
    "product_id__pack_format",
    "product_id__pack_size",
    "product_id__number_in_pack",
    "product_id__pack_type",
    "product_id__ppg",
    "product_id__flavour",
    "product_id__product_size",
    "product_id__product_description",
    "product_id__product_long_description",
    "product_id__ean_code",
    "product_id__Growth_Drivers",
  ];
  const includeAllLevelsonLoad = [
    "customer_id__market",
    "customer_id__customer_desc",
    "customer_id__channel",
    "customer_id__retailer",
    "product_id__animal_type",
    "product_id__portfolio",
    "product_id__technology",
    "product_id__manufacturer",
    "product_id__brand",
  ];
  const includeNoLevel = [];
  const reset_filters = {
    product_pet: [],
    product_portfolio: [],
    product_technology: [],
    product_manufacturer: [],
    product_brand: [],
    product_local_manufacturer: [],
    product_local_brand: [],
    product_sub_brand: [],
    product_pack_format: [],
    product_number_in_pack: [],
    product_pack_type: [],
    product_ppg: [],
    product_flavour: [],
    product_size: [],
    product_description: [],
    product_long_description: [],
    product_ean_code: [],
    Growth_Drivers: [],
    periodicity: [],
    kpis: [],
    time_frames: [],
  };
  const reset_cust_filters = {
    customer_type: [],
    customer_retail: [],
    customer_channel: [],
    customer_market: [],
    customer_desc: [],
  };
  //for updating the dataset, filters data, bookmarks on page load
  useEffect(() => {
    dispatch(setDatasetNielsen("nielsen"));
    dispatch(getNielsenCustomerFilters());
    dispatch(getNielsenProductFilters());
    dispatch(getNielsenKPIs());
    dispatch(getEposKPIs());
    dispatch(getNielsenBookmarks(nielsen_dataset_selected));
  }, []);
  //below two functions are for export modal
  const handleOk = () => {
    setLoadingModal(true);
    setTimeout(() => {
      setLoadingModal(false);
      setOpenModal(false);
    }, 3000);
  };
  const handleCancel = () => {
    setOpenModal(false);
  };
  //export button main function
  const handleExport = () => {
    {
      timeHorizonRadioNielsen === "rolledup"
        ? dispatch(
            getnielsenDataDownloadRolledUp(
              { ...cust_filters_nielsen, ...prod_filters_nielsen },
              kpis,
              periodicity,
              nielsentimeframeCheckbox,
              nielsen_columnSelectionCheckbox,
              nielsen_dataset_selected,
              timeHorizonRadioNielsen
            )
          )
        : dispatch(
            getnielsenDataDownloadDynamicWeekly(
              {
                ...cust_filters_nielsen,
                ...prod_filters_nielsen,
              },
              kpis,
              nielsenYear,
              nielsenYearPeriod,
              nielsenYearPeriodWeek,
              nielsentimeframeCheckbox,
              nielsen_columnSelectionCheckbox,
              nielsen_dataset_selected,
              timeHorizonRadioNielsen
            )
          );
    }
    setOpenPreviewModal(false);
  };
  //below two functions are for preview modal
  const handleOkPreview = () => {
    setLoadingPreviewModal(true);
    setTimeout(() => {
      setLoadingPreviewModal(false);
      setOpenPreviewModal(false);
    }, 3000);
  };
  const handleCancelPreview = () => {
    setOpenPreviewModal(false);
  };
  //function for updating the periodicity filter after selecting values from dropdown (in rolled-up scenario)
  const onSelection = (key, value) => {
    let newProdFilters = {
      ...prod_filters_nielsen,
      [key]: value,
    };
    dispatch(setNielsenProdFilters(newProdFilters));
  };
  //function for handling periodicity filter after clearing the selected options from dropdown (in rolled-up scenario)
  const handleOnClear = (key, value) => {
    let newFilters = {
      ...prod_filters_nielsen,
      [key]: value,
    };
    dispatch(setNielsenProdFilters(newFilters));
    dispatch(getNielsenProductFilters(newFilters));
  };
  //main function for reset
  const handleReset = () => {
    setApplyErrorMarket("");
    setApplyErrorCd("");
    dispatch(setNielsenCustFilters(reset_cust_filters));
    dispatch(setNielsenWeeklyCustFilters(reset_cust_filters));
    dispatch(setNielsenProdFilters(reset_filters));
    dispatch(getNielsenCustomerFilters(reset_cust_filters));
    dispatch(getNielsenProductFilters(reset_filters));
    dispatch(setnielsenTimeframeCheckbox([]));
    dispatch(setnielsencolumnSelectionCheckbox(includeAllLevelsonLoad));
    dispatch(setincludeAllCheckboxNielsen([""]));
    dispatch(setNielsenTableDataPreview([]));
    dispatch(setNielsenTableDataPreviewColumns([]));
    dispatch(setTimeSelectedDynamicWeeklyNielsen([]));
    dispatch(setnumOfRows(0));
    dispatch(setnumOfColumns(0));
  };
  //functions for bookmark modal
  const openBookmarkModal = () => {
    setBookmarkModalOn(true);
    dispatch(getNielsenBookmarks(nielsen_dataset_selected));
  };
  const handleOkBookmarkModal = () => {
    setBookmarkModalOn(false);
  };
  const handleCancelBookmarkModal = () => {
    setBookmarkModalOn(false);
  };
  //function for updating the Calendar - Time Selection filter after selecting values from dropdown (in dynamic weekly scenario)
  const onSelectingTimePeriod = (value) => {
    let newTimePeriod = value;
    let yearSelection = [];
    let yearPeriodSelection = [];
    let yearPeriodWeekSelection = [];
    let year_only = value.filter(
      (val) => val.includes("P") === false && val.includes("W") === false
    );
    yearSelection = year_only;
    let period_values = value.filter(
      (val) => val.includes("P") === true && val.includes("W") === false
    );
    yearPeriodSelection = period_values;
    let period_week_values = value.filter(
      (val) => val.includes("P") === true && val.includes("W") === true
    );
    yearPeriodWeekSelection = period_week_values;
    setTimeSelected(newTimePeriod);
    dispatch(setTimeSelectedDynamicWeeklyNielsen(newTimePeriod));
    dispatch(setNielsenYear(yearSelection));
    dispatch(setNielsenYearPeriod(yearPeriodSelection));
    dispatch(setNielsenYearPeriodWeek(yearPeriodWeekSelection));
  };
  //function for updating time frames checkboxes - Include YA, Include 2YA
  const timeframeSelection = () => (e) => {
    if (e.target.checked) {
      let value = [...nielsentimeframeCheckbox];
      value.push(e.target.value);
      dispatch(setnielsenTimeframeCheckbox(value));
    } else {
      let value = [...nielsentimeframeCheckbox];
      value = value.filter((val) => val !== e.target.value);
      dispatch(setnielsenTimeframeCheckbox(value));
    }
  };
  //function for updating radio selection for rolled-up/dynamic weekly
  const timeHorizonRadioSelection = () => (e) => {
    if (e.target.checked) {
      dispatch(setNielsenTimeHorizonRadio(e.target.value));
    }
  };
  //function for updating Include All checkbox
  const include_all_Selection = () => (e) => {
    if (e.target.checked) {
      dispatch(setincludeAllCheckboxNielsen(["include_all_levels"]));
      dispatch(setnielsenTimePeriodCheckbox(["l4w"]));
      dispatch(setnielsencolumnSelectionCheckbox(includeAllLevels));
    } else {
      dispatch(setincludeAllCheckboxNielsen([""]));
      dispatch(setnielsenTimePeriodCheckbox([]));
      dispatch(setnielsencolumnSelectionCheckbox(includeNoLevel));
    }
  };
  //for preparing data in Calendar - Time Selection filter in dynamic weekly scenario
  useEffect(() => {
    if (
      timeSelection_calendar &&
      Object.keys(timeSelection_calendar).length > 0
    ) {
      let weekperiodYear = timeSelection_calendar;
      setTimePeriod(
        Object.keys(weekperiodYear).map((year) => ({
          title: year,
          value: year,
          key: year,
          children: year
            ? Object.keys(weekperiodYear[year]).map((period) => ({
                title: `${year} ${period}`,
                value: `${year} ${period}`,
                key: period,
                children: period
                  ? weekperiodYear[year][period].map((week) => ({
                      title: `${year} ${period} ${week}`,
                      value: `${year} ${period} ${week}`,
                      key: week,
                    }))
                  : [],
              }))
            : [],
        }))
      );
    }
  }, [timeSelection_calendar]);
  //function for obtaining preview in rolled-up state
  const getTableDataPreviewRolledUp =
    (
      filters_nielsen,
      kpis,
      periodicityRolledup,
      nielsentimeframeCheckbox,
      nielsen_columnSelectionCheckbox,
      nielsen_dataset_selected,
      timeHorizonRadioNielsen,
      previewFormatNielsen
    ) =>
    async (dispatch, getState) => {
      let filters_nielsen = {};
      let kpis = [];
      let periodicityRolledup = prod_filters_nielsen.periodicity;
      filters_nielsen = { ...cust_filters_nielsen, ...prod_filters_nielsen };
      kpis = cust_filters_nielsen.kpis;
      if (
        typeof periodicityRolledup !== "undefined" &&
        periodicityRolledup.length > 0
      ) {
        periodicityRolledup = prod_filters_nielsen.periodicity;
      } else {
        periodicityRolledup = prod_data_filters_nielsen.periodicity;
      }
      let newFilters = { ...filters_nielsen };
      // Remove Empty Key Value Pairs
      Object.keys(newFilters).forEach((key) => {
        if (newFilters[key].length === 0) {
          delete newFilters[key];
        }
      });
      const asArrayflatten = Object.entries(newFilters);
      const groupArray = [];
      var i;
      for (i = 0; i < Object.keys(newFilters).length; i++) {
        groupArray.push([
          Object.values(asArrayflatten)[i][0],
          Object.values(asArrayflatten)[i][1].filter((val) => val !== "ALL"),
        ]);
      }
      const payloadFiltersArray = [];
      var j;
      for (j = 0; j < Object.keys(groupArray).length; j++) {
        if (groupArray[j][1].length > 0) {
          payloadFiltersArray.push([groupArray[j][0], groupArray[j][1]]);
        }
      }
      const payloadFilters = Object.fromEntries(payloadFiltersArray);
      let column_filters = payloadFilters;
      let kpi_combination = kpis;
      let periodicity = periodicityRolledup;
      let time_frames = nielsentimeframeCheckbox;
      let column_selection = nielsen_columnSelectionCheckbox;
      let dataset = nielsen_dataset_selected;
      let timeHorizon = timeHorizonRadioNielsen;
      let preview_format = previewFormatNielsen;
      dispatch(setNielsenTableLoading(true));
      CustomAxios(API.table_preview, "POST", {
        column_filters,
        kpi_combination,
        periodicity,
        time_frames,
        column_selection,
        dataset,
        timeHorizon,
        preview_format,
      })
        .then((response) => {
          if (response?.status === 200) {
            dispatch(setNielsenTableDataPreview(response.data.preview_data));
            dispatch(setnumOfRows(response.data.no_of_rows));
            dispatch(setnumOfColumns(response.data.no_of_columns));
            let columns = Object.keys(response.data.preview_data[0]).map(
              (val) => {
                return {
                  title: val.split("_").join(" ").toUpperCase(),
                  dataIndex: val,
                  width: val.length * 5,
                };
              }
            );
            dispatch(setNielsenTableDataPreviewColumns(columns));
            dispatch(setNielsenTableLoading(false));
          } else {
            showErrorMessage();
          }
        })
        .catch((err) => {
          if (err.status === 403) {
            CheckAuthorization();
          }
          setOpenPreviewModal(true);
          console.error("Data Preview Refresh failed", err);
          dispatch(
            getTableDataPreviewRolledUp(
              column_filters,
              kpi_combination,
              periodicity,
              time_frames,
              column_selection,
              dataset,
              timeHorizon,
              (preview_format = true)
            )
          );
          dispatch(setNielsenTableLoading(false));
        });
    };
  //function for obtaining preview in dynamic weekly state
  const getTableDataPreviewDynamicWeekly =
    (
      filters_nielsen,
      kpis,
      nielsenYear,
      nielsenYearPeriod,
      nielsenYearPeriodWeek,
      nielsentimeframeCheckbox,
      nielsen_columnSelectionCheckbox,
      nielsen_dataset_selected,
      timeHorizonRadioNielsen,
      previewFormatNielsen
    ) =>
    async (dispatch, getState) => {
      let filters_nielsen = {};
      let kpis = [];
      const filteredObject = Object.fromEntries(
        Object.entries(prod_filters_nielsen).filter(
          ([key, value]) => key !== "periodicity"
        )
      );
      filters_nielsen = {
        ...cust_filters_nielsen,
        ...filteredObject,
      };
      kpis = cust_filters_nielsen.kpis;
      let newFilters = { ...filters_nielsen };

      // Remove Empty Key Value Pairs
      Object.keys(newFilters).forEach((key) => {
        if (newFilters[key].length === 0) {
          delete newFilters[key];
        }
      });
      const asArrayflatten = Object.entries(newFilters);
      const groupArray = [];
      var i;
      for (i = 0; i < Object.keys(newFilters).length; i++) {
        groupArray.push([
          Object.values(asArrayflatten)[i][0],
          Object.values(asArrayflatten)[i][1],
        ]);
      }
      const payloadFiltersArray = [];
      var j;
      for (j = 0; j < Object.keys(groupArray).length; j++) {
        if (groupArray[j][1].length > 0) {
          payloadFiltersArray.push([groupArray[j][0], groupArray[j][1]]);
        }
      }
      const payloadFilters = Object.fromEntries(payloadFiltersArray);
      let column_filters = payloadFilters;
      let kpi_combination = kpis;
      let year = nielsenYear;
      let yearPeriod = nielsenYearPeriod;
      let yearPeriodWeek = nielsenYearPeriodWeek;
      let time_frames = nielsentimeframeCheckbox;
      let column_selection = nielsen_columnSelectionCheckbox;
      let dataset = nielsen_dataset_selected;
      let timeHorizon = timeHorizonRadioNielsen;
      let preview_format = previewFormatNielsen;
      dispatch(setNielsenTableLoading(true));
      CustomAxios(API.table_preview, "POST", {
        column_filters,
        kpi_combination,
        year,
        yearPeriod,
        yearPeriodWeek,
        time_frames,
        column_selection,
        dataset,
        timeHorizon,
        preview_format,
      })
        .then((response) => {
          if (response?.status === 200) {
            dispatch(setNielsenTableDataPreview(response.data.preview_data));
            dispatch(setnumOfRows(response.data.no_of_rows));
            dispatch(setnumOfColumns(response.data.no_of_columns));
            let columns = Object.keys(response.data.preview_data[0]).map(
              (val) => {
                return {
                  title: val.split("_").join(" ").toUpperCase(),
                  dataIndex: val,
                  width: val.length * 5,
                };
              }
            );
            dispatch(setNielsenTableDataPreviewColumns(columns));
            dispatch(setNielsenTableLoading(false));
          } else {
            showErrorMessage();
          }
        })
        .catch((err) => {
          if (err.status === 403) {
            CheckAuthorization();
          }
          setOpenPreviewModal(true);
          console.error("Data Preview Refresh failed", err);
          dispatch(
            getTableDataPreviewDynamicWeekly(
              column_filters,
              kpi_combination,
              year,
              yearPeriod,
              yearPeriodWeek,
              time_frames,
              column_selection,
              dataset,
              timeHorizon,
              (preview_format = true)
            )
          );
          dispatch(setNielsenTableLoading(false));
        });
    };
  //function for getting data download in rolled-up state
  const getnielsenDataDownloadRolledUp =
    (
      filters_nielsen,
      kpis,
      periodicityDownload,
      nielsentimeframeCheckbox,
      nielsen_columnSelectionCheckbox,
      nielsen_dataset_selected,
      timeHorizonRadioNielsen
    ) =>
    async (dispatch, getState) => {
      let filters_nielsen = {};
      let kpis = [];
      let periodicityDownload = prod_filters_nielsen.periodicity;
      dispatch(setLoadingNielsen(true));
      filters_nielsen = { ...cust_filters_nielsen, ...prod_filters_nielsen };
      kpis = cust_filters_nielsen.kpis;
      if (
        typeof periodicityDownload !== "undefined" &&
        periodicityDownload.length > 0
      ) {
        periodicityDownload = prod_filters_nielsen.periodicity;
      } else {
        periodicityDownload = prod_data_filters_nielsen.periodicity;
      }
      let newFilters = { ...filters_nielsen };
      Object.keys(newFilters).forEach((key) => {
        if (newFilters[key].length === 0) {
          delete newFilters[key];
        }
      });
      const asArrayflatten = Object.entries(newFilters);
      const groupArray = [];
      var i;
      for (i = 0; i < Object.keys(newFilters).length; i++) {
        groupArray.push([
          Object.values(asArrayflatten)[i][0],
          Object.values(asArrayflatten)[i][1].filter((val) => val !== "ALL"),
        ]);
      }
      const payloadFiltersArray = [];
      var j;
      for (j = 0; j < Object.keys(groupArray).length; j++) {
        if (groupArray[j][1].length > 0) {
          payloadFiltersArray.push([groupArray[j][0], groupArray[j][1]]);
        }
      }
      const payloadFilters = Object.fromEntries(payloadFiltersArray);
      let column_filters = payloadFilters;
      let kpi_combination = kpis;
      let periodicity = periodicityDownload;
      let time_frames = nielsentimeframeCheckbox;
      let column_selection = nielsen_columnSelectionCheckbox;
      let dataset = nielsen_dataset_selected;
      let timeHorizon = timeHorizonRadioNielsen;
      setExportLoading(true);
      dispatch(setNielsenExportDataLoading(true));
      CustomAxiosDE(API.export_data, "POST", {
        column_filters,
        kpi_combination,
        periodicity,
        time_frames,
        column_selection,
        dataset,
        timeHorizon,
      })
        .then((response) => {
          if (response?.status === 200) {
            setOpenModal(true);
            const export_data = response.data.preview_data;
            setExportLoading(false);
            dispatch(setNielsenExportData(export_data));
            dispatch(setNielsenExportDataLoading(false));
          } else {
            showErrorMessage();
          }
        })
        .catch((err) => {
          console.error("error, Error initiating download", err);
          showErrorMessage();
          if (err.status === 403) {
            CheckAuthorization();
          }
          setExportLoading(false);
          dispatch(setNielsenExportDataLoading(false));
        });
    };
  //function for getting data download in dynamic weekly state
  const getnielsenDataDownloadDynamicWeekly =
    (
      filters,
      kpis,
      nielsenYear,
      nielsenYearPeriod,
      nielsenYearPeriodWeek,
      nielsentimeframeCheckbox,
      nielsen_columnSelectionCheckbox,
      nielsen_dataset_selected,
      timeHorizonRadioNielsen
    ) =>
    async (dispatch, getState) => {
      dispatch(setLoadingNielsen(true));
      let filters = {};
      const filteredObject = Object.fromEntries(
        Object.entries(prod_filters_nielsen).filter(
          ([key, value]) => key !== "periodicity"
        )
      );
      filters = {
        ...cust_filters_nielsen,
        ...filteredObject,
      };
      let newFilters = { ...filters };
      Object.keys(newFilters).forEach((key) => {
        if (newFilters[key].length === 0) {
          delete newFilters[key];
        }
      });
      const asArrayflatten = Object.entries(newFilters);
      const groupArray = [];
      var i;
      for (i = 0; i < Object.keys(newFilters).length; i++) {
        groupArray.push([
          Object.values(asArrayflatten)[i][0],
          Object.values(asArrayflatten)[i][1],
        ]);
      }
      const payloadFiltersArray = [];
      var j;
      for (j = 0; j < Object.keys(groupArray).length; j++) {
        if (groupArray[j][1].length > 0) {
          payloadFiltersArray.push([groupArray[j][0], groupArray[j][1]]);
        }
      }
      const payloadFilters = Object.fromEntries(payloadFiltersArray);
      let column_filters = payloadFilters;
      let kpi_combination = payloadFilters.kpis;
      let year = nielsenYear;
      let yearPeriod = nielsenYearPeriod;
      let yearPeriodWeek = nielsenYearPeriodWeek;
      let time_frames = nielsentimeframeCheckbox;
      let column_selection = nielsen_columnSelectionCheckbox;
      let dataset = nielsen_dataset_selected;
      let timeHorizon = timeHorizonRadioNielsen;
      setExportLoading(true);
      dispatch(setNielsenExportDataLoading(true));
      CustomAxiosDE(API.export_data, "POST", {
        column_filters,
        kpi_combination,
        year,
        yearPeriod,
        yearPeriodWeek,
        time_frames,
        column_selection,
        dataset,
        timeHorizon,
      })
        .then((response) => {
          if (response?.status === 200) {
            setOpenModal(true);
            const export_data = response.data.preview_data;
            setExportLoading(false);
            dispatch(setNielsenExportData(export_data));
            dispatch(setNielsenExportDataLoading(false));
          } else {
            showErrorMessage();
          }
        })
        .catch((err) => {
          console.error("error, Error initiating download", err);
          showErrorMessage();
          if (err.status === 403) {
            CheckAuthorization();
          }
          setExportLoading(false);
          dispatch(setNielsenExportDataLoading(false));
        });
    };

  return (
    <Wrapper heading={"2"}>
      <Content className="content-body-nielsen">
        <Loader loading={loading > 0} tip={"Please wait.."}>
          <Row gutter={20} wrap={false} className="export-row-width">
            <Col span={24}>
              <Loader
                loading={nielsendropdownLoading > 0}
                tip="Please wait while export filters are loaded.."
              >
                <div className="nielsen-page">
                  <div className="header-row-contents">
                    <h3>Nielsen Data Download</h3>
                    <span className="right-filter">
                      Include All level in Data
                    </span>
                    <Checkbox
                      className="include-all-checkbox"
                      value={"include_all_levels"}
                      checked={
                        !!includeAllCheckbox_nielsen &&
                        includeAllCheckbox_nielsen.includes(
                          "include_all_levels"
                        )
                      }
                      onChange={include_all_Selection()}
                    />
                    <button className="reset-text">Reset</button>
                    <div
                      className="reset-button-components"
                      onClick={() => handleReset()}
                    >
                      <span className="reset-button-1">
                        <img src={ellipse152} />
                      </span>
                      <span className="reset-button-2">
                        <img src={ellipse153} />
                      </span>
                    </div>
                    <button className="bookmark-text">Bookmark</button>
                    <div
                      className="bookmark-component"
                      onClick={() => openBookmarkModal()}
                    >
                      <span className="smaller-block">
                        <img src={smallerblock} />
                      </span>
                      <span className="larger-block">
                        <img src={largerblock} />
                      </span>
                    </div>
                    <Modal
                      title="Personal Bookmarks"
                      bodyStyle={{ height: "fit-content" }}
                      className="nielsen-bookmark-modal"
                      visible={bookmarkModalOn}
                      onOk={handleOkBookmarkModal}
                      onCancel={handleCancelBookmarkModal}
                      footer={null}
                    >
                      <Bookmarks
                        bookmarkOn={bookmarkModalOn}
                        hideBookmark={() => setBookmarkModalOn(false)}
                        dataset={"nielsen"}
                      />
                    </Modal>
                    <ToastContainer />
                  </div>
                  <Row className="filters-sections">
                    <Col md={12}>
                      <span className="solid-background"></span>
                      <h5>
                        Time Horizon
                        <div
                          style={{ display: "inline-flex", marginLeft: 150 }}
                        >
                          <Radio
                            style={{ color: "#0000a0" }}
                            value={"rolledup"}
                            checked={
                              !!timeHorizonRadioNielsen &&
                              timeHorizonRadioNielsen.includes("rolledup")
                            }
                            onChange={timeHorizonRadioSelection()}
                          >
                            Rolled-up Level
                          </Radio>
                          <Radio
                            style={{ color: "#0000a0" }}
                            value={"weekly"}
                            checked={
                              !!timeHorizonRadioNielsen &&
                              timeHorizonRadioNielsen.includes("weekly")
                            }
                            onChange={timeHorizonRadioSelection()}
                          >
                            Dynamic Weekly
                          </Radio>
                        </div>
                      </h5>

                      {timeHorizonRadioNielsen === "weekly" ? (
                        <Row
                          gutter={10}
                          style={{ marginTop: 10, marginBottom: 10 }}
                        >
                          <Col md={16} style={{ marginTop: 32 }}>
                            <h5
                              style={{ marginTop: "-20px", marginLeft: "10px" }}
                            >
                              Calendar - Time Selection
                            </h5>
                            <TreeSelect
                              dropdownMatchSelectWidth={false}
                              showSearch={true}
                              placeholder={"All"}
                              multiple
                              treeCheckable={true}
                              showCheckedStrategy={SHOW_PARENT}
                              value={timeSelectedDynamicNielsen}
                              onChange={(value) => onSelectingTimePeriod(value)}
                              style={{ width: "100%", minWidth: 300 }}
                              dropdownStyle={{ minWidth: "20%" }}
                              treeData={timePeriod}
                              allowClear
                            />
                          </Col>
                          <div style={{ marginTop: 20, marginBottom: 32 }}>
                            *Weekly can be downloaded for one market at time
                          </div>
                          <Row
                            style={{
                              marginTop: 60,
                              marginBottom: 32,
                              marginLeft: -322,
                            }}
                          >
                            <Checkbox
                              value={"ya"}
                              checked={
                                !!nielsentimeframeCheckbox &&
                                nielsentimeframeCheckbox.includes("ya")
                              }
                              onChange={timeframeSelection()}
                              style={{ marginLeft: 5 }}
                            >
                              Include YA
                            </Checkbox>
                            <Checkbox
                              value={"2ya"}
                              checked={
                                !!nielsentimeframeCheckbox &&
                                nielsentimeframeCheckbox.includes("2ya")
                              }
                              onChange={timeframeSelection()}
                              style={{ marginLeft: 6.262 }}
                            >
                              Include 2YA
                            </Checkbox>
                          </Row>
                        </Row>
                      ) : (
                        <Row
                          gutter={10}
                          style={{ marginTop: 10, marginBottom: 10 }}
                        >
                          <Col md={8} className="dropdown-card">
                            <label
                              className="label-block-nielsen"
                              style={{ marginTop: "5px", marginLeft: "29px" }}
                            >
                              Select Rolled-up{" "}
                            </label>
                            <Select
                              dropdownMatchSelectWidth={false}
                              value={prod_filters_nielsen.periodicity}
                              onChange={(val) =>
                                onSelection("periodicity", val)
                              }
                              onClear={() => {
                                handleOnClear(
                                  "periodicity",
                                  prod_data_filters_nielsen.periodicity
                                );
                              }}
                              placeholder="All"
                              mode="multiple"
                              maxTagCount="responsive"
                              placement="bottomLeft"
                              allowClear
                              bordered={true}
                              style={{ width: "100%", marginTop: "10px" }}
                            >
                              {periodicity?.map((val) => (
                                <Select.Option value={val}>{val}</Select.Option>
                              ))}
                            </Select>
                          </Col>
                          <Checkbox
                            value={"ya"}
                            checked={
                              !!nielsentimeframeCheckbox &&
                              nielsentimeframeCheckbox.includes("ya")
                            }
                            onChange={timeframeSelection()}
                            style={{ marginLeft: 200, marginTop: 31.5 }}
                          >
                            Include YA
                          </Checkbox>
                          <Checkbox
                            value={"2ya"}
                            checked={
                              !!nielsentimeframeCheckbox &&
                              nielsentimeframeCheckbox.includes("2ya")
                            }
                            onChange={timeframeSelection()}
                            style={{ marginLeft: 6.26, marginTop: 31.5 }}
                          >
                            Include 2YA
                          </Checkbox>
                          <div style={{ marginTop: 20, marginBottom: 32 }}>
                            *Roll up data is available for as of date only{" "}
                          </div>
                        </Row>
                      )}
                        {
                        timeHorizonRadioNielsen === "rolledup" ?
                        ( <CustFiltersSection applyErrorCd={applyErrorCd} />)
                        :
                        (timeHorizonRadioNielsen === "weekly"&&
                        customerFiltersWeekly.customer_market.length === 0 ?
                        (<CustFiltersSection applyErrorMarket={applyErrorMarket} /> )
                        :
                        (<CustFiltersSection applyErrorCd={applyErrorCd} />  )
                        
                        )
                      } 
                    </Col>
                    <Col md={2}></Col>
                    <Col md={10}>
                      <ProdFiltersSection />
                    </Col>
                  </Row>
                  <Row gutter={10}>
                    <Col md={2}></Col>
                    <Col md={10}>
                      <Row
                        gutter={10}
                        style={{
                          marginTop: 10,
                          marginLeft: "980px",
                          display: "inline-flex",
                        }}
                      >
                        <Col
                          md={8}
                          style={{ display: "flex", justifyContent: "end" }}
                        >
                          {timeHorizonRadioNielsen === "rolledup" ? (
                            <Button
                              type="primary"
                              loading={nielsentableLoading > 0}
                              onClick={() => {
                               let mark_market=customer_desc.filter((val)=>cust_filters_nielsen.customer_desc.includes(val.customer_desc)).map((i)=>i.market)
                               let ml=mark_market.filter((q, idx) => mark_market.indexOf(q) === idx)
                               let x= cust_filters_nielsen.customer_market.length===0 ? 4:cust_filters_nielsen.customer_market.length

                               if (ml.length!==0 && ml.length===x)
                               {
                                 setApplyErrorCd(false);
                                 dispatch(
                                   getTableDataPreviewRolledUp(
                                     {
                                       ...cust_filters_nielsen,
                                       ...prod_filters_nielsen,
                                     },
                                     kpis,
                                     periodicity,
                                     nielsentimeframeCheckbox,
                                     nielsen_columnSelectionCheckbox,
                                     nielsen_dataset_selected,
                                     timeHorizonRadioNielsen,
                                     previewFormatNielsen
                                   )
                                 );
                               
                             }
                             else{
                               setApplyErrorCd(true);
                             }
                           }}
                            >
                              Load Preview
                            </Button>
                          ) : (
                            <Button
                              type="primary"
                              loading={nielsentableLoading > 0}
                              onClick={() => {
                                if (cust_filters_nielsen.customer_market.length !== 0 &&
                                  cust_filters_nielsen.customer_desc.length !== 0
                                ) {
                                    setApplyErrorCd(false);
                                      dispatch(
                                        getTableDataPreviewDynamicWeekly(
                                          {
                                            ...cust_filters_nielsen,
                                            ...prod_filters_nielsen,
                                          },
                                          kpis,
                                          nielsenYear,
                                          nielsenYearPeriod,
                                          nielsenYearPeriodWeek,
                                          nielsentimeframeCheckbox,
                                          nielsen_columnSelectionCheckbox,
                                          nielsen_dataset_selected,
                                          timeHorizonRadioNielsen,
                                          previewFormatNielsen
                                        )
                                      );
                                      setApplyErrorMarket(false);
                                      
                                    }
                                  
                              else if(cust_filters_nielsen.customer_market.length === 0){
                                setApplyErrorMarket(true); 
                              }
                              else if( cust_filters_nielsen.customer_market.length !== 0 &&
                                cust_filters_nielsen.customer_desc.length === 0){
                                setApplyErrorCd(true);
                              }
                              }}
                            >
                              Load Preview
                            </Button>
                          )}
                          <Modal
                            visible={openPreviewModal}
                            title={<img src={envelope}></img>}
                            onOk={handleOkPreview}
                            onCancel={handleCancelPreview}
                            className="previewModalStyle"
                            footer={[
                              <Button
                                key="submit"
                                type="primary"
                                loading={loadingModal}
                                onClick={handleExport}
                              >
                                Export
                              </Button>,
                            ]}
                          >
                            <p>
                              Preview is taking more time than usual due to the
                              large size of the data, we have loaded the
                              structure of output data for you.
                            </p>

                            <p>
                              You can click on Export to get the download link
                            </p>
                          </Modal>
                          <ToastContainer />
                        </Col>
                        <Col md={4}>
                          {timeHorizonRadioNielsen === "rolledup" ? (
                            <Button
                              type="primary"
                              loading={exportLoading}
                              disabled={nielsendropdownLoading > 0}
                              onClick={() => {
                                let mark_market=customer_desc.filter((val)=>cust_filters_nielsen.customer_desc.includes(val.customer_desc)).map((i)=>i.market)
                               
                                let ml=mark_market.filter((q, idx) => mark_market.indexOf(q) === idx)
                                //let x=  cust_filters_nielsen.customer_market.length
                                 let x= cust_filters_nielsen.customer_market.length===0 ? 4:cust_filters_nielsen.customer_market.length

                                if (ml.length!==0 && ml.length===x){
                                  setApplyErrorCd(false);
                                dispatch(
                                  getnielsenDataDownloadRolledUp(
                                    {
                                      ...cust_filters_nielsen,
                                      ...prod_filters_nielsen,
                                    },
                                    kpis,
                                    periodicity,
                                    nielsentimeframeCheckbox,
                                    nielsen_columnSelectionCheckbox,
                                    nielsen_dataset_selected,
                                    timeHorizonRadioNielsen
                                  )
                                );
                              }
                              else{
                                setApplyErrorCd(true);
                              }
                              }}
                            >
                              Export Data
                            </Button>
                          ) : (
                            <Button
                              type="primary"
                              loading={exportLoading}
                              disabled={nielsendropdownLoading > 0}
                              onClick={() => {
                                if (cust_filters_nielsen.customer_market.length !== 0 &&
                                  cust_filters_nielsen.customer_desc.length !== 0
                                ) {
                                    setApplyErrorCd(false);
                                     dispatch(
                                    getnielsenDataDownloadDynamicWeekly(
                                      {
                                        ...cust_filters_nielsen,
                                        ...prod_filters_nielsen,
                                      },
                                      kpis,
                                      nielsenYear,
                                      nielsenYearPeriod,
                                      nielsenYearPeriodWeek,
                                      nielsentimeframeCheckbox,
                                      nielsen_columnSelectionCheckbox,
                                      nielsen_dataset_selected,
                                      timeHorizonRadioNielsen
                                    )
                                  );
                                  setApplyErrorMarket(false);
                                      
                                }
                              
                          else if(cust_filters_nielsen.customer_market.length === 0){
                            setApplyErrorMarket(true); 
                          }
                          else if( cust_filters_nielsen.customer_market.length !== 0 &&
                            cust_filters_nielsen.customer_desc.length === 0){
                            setApplyErrorCd(true);
                          }
                              }}
                            >
                              Export Data
                            </Button>
                          )}
                          <Modal
                            visible={openModal}
                            title={<img src={envelope}></img>}
                            onOk={handleOk}
                            onCancel={handleCancel}
                            className="exportModalStyle"
                            footer={null}
                          >
                            <p>
                              {" "}
                              The download will be shared with you on your email
                              ID{" "}
                            </p>

                            <p>{email_home} .</p>
                          </Modal>
                          <ToastContainer />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Loader loading={nielsentableLoading > 0} tip="Loading..">
                    <Row className="data-preview-table">
                      <span className="table-header">Data Preview</span>
                      <Table
                        rowKey="index"
                        dataSource={nielsentabledataPreview}
                        className="custom-table"
                        columns={nielsentabledataPreviewColumns}
                        pagination={{ pageSize: 200 }}
                        scroll={{
                          x: nielsentabledataPreviewColumns.length * 250,
                          y: 400,
                        }}
                      />
                    </Row>
                  </Loader>

                  <Row style={{ marginTop: 10 }}>
                    <Col span={24}>
                      <div className="d-right">
                        <div
                          style={{ textAlign: "right", marginBottom: 10 }}
                        ></div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Loader>
            </Col>
          </Row>
        </Loader>
      </Content>
    </Wrapper>
  );
};

export default withRouter(Nielsen);
